'use strict';

var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var React = require('react');
var react = require('@emotion/react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);

var createStoreProvider = function createStoreProvider(_ref) {
  var initialState = _ref.initialState,
    reducer = _ref.reducer,
    Provider = _ref.Provider;
  return function (_ref2) {
    var children = _ref2.children;
    var _useReducer = React.useReducer(reducer, initialState),
      _useReducer2 = _slicedToArray__default["default"](_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];
    /* Reinspect config for development */
    // const [state, dispatch] = useReducer(reducer, initialState, a => a, 'App');
    // Important(!): memoize array value. Else all context consumers update on *every* render
    var store = React.useMemo(function () {
      return {
        state: state,
        dispatch: dispatch
      };
    }, [state]);
    return react.jsx(Provider, {
      value: store
    }, children);
  };
};

exports.createStoreProvider = createStoreProvider;
//# sourceMappingURL=createStoreProvider-55b8195c.js.map
